import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from './config/router'
import VueTooltip from 'vue-directive-tooltip'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'
import VueTabs from 'vue-nav-tabs/dist/vue-tabs.js'
import 'vue-nav-tabs/themes/vue-tabs.css'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import vMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PayPal from 'vue-paypal-checkout';



import { store } from './config/store'
import { getMessage } from './assets/js/library.js';
import { updateFields } from './assets/js/library.js';
import { printDataToPdf } from './assets/js/printPdf.js';

// register globally
Vue.component('multiselect', vMultiselect)
Vue.component('v-select', vSelect)
Vue.use(VueResource);
Vue.use(VueTooltip);
Vue.use(VueTabs);
Vue.use(VueFormWizard);
Vue.component('paypal-checkout', PayPal)

Vue.config.productionTip = false;
//Vue.http.options.root = 'http://localhost/api';
Vue.http.options.root = 'https://thalofinancial.com/api/';
//Vue.http.options.root = 'https://crissercorporacion.com/api/';

Vue.directive('style', {
    bind(el, binding, vnode){
        if (binding.value.family){
            el.style.fontFamily = binding.value.family;
        }
        if (binding.value.color){
            el.style.color = binding.value.color;
        }
        if (binding.value.size){
            el.style.fontSize = binding.value.size;
        }
        if (binding.modifiers['bold']){
            el.style.fontWeight = 'bold';
        }
        if (binding.modifiers['italic']){
            el.style.fontStyle = 'italic';
        }
    }
});


Vue.prototype.$getVariable = function(p_errorMessage, p_messages) {
    let url = 'variable/get/all';
    this.$http.post(url)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    let objFields = new Object();
                    let field = "";
                    for(var i in data){
                        objFields[data[i].variable] = data[i].valor;
                    }
                    objFields.data = data;
                    let stringJSON = JSON.stringify(objFields);
                    localStorage.setItem(this.$store.state.LIST_VARIABLE, stringJSON);
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
        })
        .catch(error => {
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
        })
}

Vue.prototype.$getFormField = function(p_fields, p_errorMessage, p_filter, p_messages, p_store, p_updateValues) {
    let url = 'formularioCampo/get/formularioIdioma';
    this.$http.post(url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    let objFields = new Object();
                    let field = "";
                    for(var i in data){
                        if (data[i].type == this.$store.state.TYPE_MENU){
                            field = data[i].field + "_active";
                            if (data[i].value == "1"){
                                objFields[field] = true;
                            } else {
                                objFields[field] = false;
                            }
                        }
                        objFields[data[i].field] = i;
                    }
                    objFields.data = data;
                    if (p_updateValues){
                        for(var i in p_updateValues){
                            objFields.data[objFields[p_updateValues[i].field]].value = p_updateValues[i].value;
                        }
                    }
                    if (p_store){
                        let stringJSON = JSON.stringify(objFields);
                        localStorage.setItem(p_fields, stringJSON);
                    } else{
                        this[p_fields] = objFields;
                    }
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
                //alert(Object.entries(result[0]));
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
        })
        .catch(error => {
            alert(Object.entries(error));
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
        })
}

Vue.prototype.$getListField = function(p_list, p_errorMessage, p_filter, p_messages, p_store) {
    let url = 'formularioCampo/get/listaIdioma';
    this.$http.post(url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    if (p_store){
                        let stringJSON = JSON.stringify(data);
                        localStorage.setItem(p_list, stringJSON);
                    } else{
                        this[p_list] = data;
                    }
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
                //alert(Object.entries(result[0]));
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
        })
        .catch(error => {
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
        })
}

Vue.prototype.$getUrlList = function(p_dataList, p_errorMessage, p_isDisabled, p_url, p_filter, p_messages, p_updateValues) {
    this[p_dataList] = [];
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    if (p_updateValues){
                        for(var index in data){
                            for(var i in p_updateValues){
                                data[index][p_updateValues[i].field] = p_updateValues[i].value;
                            }
                        }
                    }
                    this[p_dataList] = data;
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
            this[p_isDisabled] = false;
        })
        .catch(error => {
            alert(Object.entries(error));
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
            this[p_isDisabled] = false;
        })
}

Vue.prototype.$getUrlListSelect = function(p_list, p_url, p_filter) {
    this[p_list] = [];
    this.$http.post(p_url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    this[p_list] = data;
                }
            }
        })
        .catch(error => {

        })
}

Vue.prototype.$getUrlData = function(p_fields, p_errorMessage, p_isDisabled, p_url, p_filter, p_messages) {
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    updateFields(data, this[p_fields]);
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
            this[p_isDisabled] = false;
        })
        .catch(error => {
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
            this[p_isDisabled] = false;
        })
}

Vue.prototype.$insertUpdate = function(p_data, p_errorMessage, p_message, p_isDisabled, p_url, p_newData, p_messages, p_tipoDato) {
    this[p_message] = "";
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_newData)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data){
                    if (Array.isArray(data)){
                        this[p_data] = data;
                    } else {
                        updateFields(data, this[p_data]);
                    }
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
                this[p_message] = getMessage(p_messages.data, p_messages.msg_5);
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
            this[p_isDisabled] = false;
        })
        .catch(error => {
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
            this[p_isDisabled] = false;
        })
}

Vue.prototype.$getUrlDataToPdf = function(p_errorMessage, p_isDisabled, p_url, p_filter, p_messages, p_properties, p_header) {
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
                if (data && data.length > 0){
                    printDataToPdf(p_properties, p_header, data);
                } else {
                    this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_4);
                }
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
            this[p_isDisabled] = false;
        })
        .catch(error => {
            this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
            this[p_isDisabled] = false;
        })
}

Vue.prototype.$getSendPdf = function(p_errorMessage, p_isDisabled, p_url, p_filter, p_messages) {
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter)
        .then(respuesta => {
            return respuesta.json();
        })
        .then(repuestaJson => {
            let repuestaObjeto;
            let data = [];
            repuestaObjeto = JSON.parse(repuestaJson);
            if (repuestaObjeto.code == this.$store.state.RESPONSE_CODE_OK){
                data = repuestaObjeto.data;
            } else {
                this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
            }
            this[p_isDisabled] = false;
        })
        .catch(error => {
           // alert(Object.entries(error));
           // this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
           // this[p_isDisabled] = false;
        })
}

new Vue({
    el: '#app',
    store,
    router: VueRouter,
    render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js